module.exports = __webpack_public_path__ + "static/media/Lee Ann Fisch Headshot_1619531786612.7d34c0ee.jpeg";